<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "voimaharjoittelun_pikaopas";
    let title = "Voimaharjoittelun pikaopas: Voiman lajit";
    let blogDate = "20.10.2015";
    let titlePic = "voimaharjoittelu.jpg";
    let firstPara = "Voima on elämisen perusehto. Lihakset tuottavat voimaa, mikä havaitaan nivelten liikkeenä tai kykynä ylläpitää asentoa. Ilman lihasvoimaa emme pysty liikkumaan, emme edes seisomaan paikallamme.";
</script>

<!-- Yhteenveto (etusivu ja blogitesktisivu) -->
{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

<!-- Vasinainen artikkeli -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>



<p>Lihasten dynaaminen voimantuotto voidaan luokitella kolmeen karkeaan ryhmään: Kestovoima, maksimivoima ja nopeusvoima. Kestovoimaksi sanotaan lihaksen kykyä jatkaa voimantuottoa pitkäkestoisessa suorituksessa, maksimivoima mittaa kykyä tuottaa voimaa yhden toiston tai hyvin lyhyen sarjan ajan ja nopeusvoima kykyä tuottaa räjähtävän nopeaa liikettä. Näillä kaikilla voiman lajeilla on omat erityispiirteensä.</p>

<p>Voiman eri osa-alueet ovat kiinteästi sidoksissa toisiinsa. Harjoittelua on syytä painottaa halutulle osa-alueelle unohtamatta muita osa-alueita. Hyvä lihaskestävyyspohja toimii kivijalkana perusvoimaharjoittelulle, joka puolestaan on välttämätön edellytys hermostolliseen maksimivoiman ja nopeusvoiman kehittämiselle.</p>

<p>Kehonmuokkausta ajatellen parhaat tulokset saavutetaan perusvoima-alueella.</p>

<h3>Voima + taito = lisää voimaa</h3>

<p>Voimaan liittyy oleellisesti taito ja tekniikka. Olipa kyse pitkän matkan juoksusta, levytankotempauksesta tai vaikkapa keihäänheitosta, kulkee kehitys käsi kädessä sekä voimatasojen että taidon kehittymisen kanssa. Juoksijan kohdalla kehitys saattaa lähteä uuteen nousuun voima- ja koordinaatioharjoittelulla. Keihäänheittäjän kaari jää lyhyeksi, jos tekniikasta ei ole tietoakaan vaikka voimaa olisi kuin pienellä rekka-autolla. Eikä painonostajakaan saa levytankoa suunnattua pään yläpuolelle pelkällä repimisellä, jos tekniikasta ei ole tietoakaan. Mitä pidemmälle voiman portaissa edetään, sitä enemmän myös taidolla on merkitystä voimantuotossa.</p>

<h3>Voiman portaat</h3>

<p>Voiman lajit ovat ikään kuin portaita, joita edetään ylhäältä alaspäin. Kuntoilijan ei tarvitse välttämättä terveysvaikutuksia hakiessaan mennä lainkaan kolmelle viimeiselle portaalle, mutta teholiikkuja ja kilpaurheilija voi tehdä huomattavankin osan harjoittelustaan näillä tehoalueilla. Toisaalta myös teholiikkujan tulee pitää huoli, että kivijalan perusta on kunnossa ja tehdä säännöllisesti myös peruskestävyys- ja voimaharjoittelua.</p>
<p>Kestävyys- ja maksimivoimaharjoittelu ovat kuitenkin ominaisuuksiltaan täysin erilaisia, ja useimmiten eri ääripäiden yhtäaikainen kehittäminen ei käytännössä onnistu. Harjoituksen painopisteitä vaihtelemalla myös harjoittelu pysyy mielekkäänä ja monipuolisena.</p>


<table>
    <thead>
        <tr>
            <th>Voiman luokka</th>
            <th>Voiman laji</th>
            <th>Esimerkkejä, joissa voiman laji ratkaisevassa osassa</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td rowspan="2">Kestovoima</td>
            <td>Lihaskestävyys</td>
            <td>Juoksu, pyöräily</td>
        </tr>
        <tr>
            <td>Voimakestävyys</td>
            <td>Kuntopiiriharjoittelu</td>
        </tr>
        <tr>
            <td rowspan="2">Maksimivoima</td>
            <td>Perusvoima</td>
            <td>Kehonrakennus</td>
        </tr>
        <tr>
            <td>Maksimivoima</td>
            <td>Voimannosto</td>
        </tr>
        <tr>
            <td rowspan="2">Nopeusvoima</td>
            <td>Pikavoima</td>
            <td>Pikajuoksu</td>
        </tr>
        <tr>
            <td>Räjähtävä voima</td>
            <td>Heitot, hypyt, painonnosto</td>
        </tr>
    </tbody>
</table>
    
    
    <p>Lihaskestävyys tarkoittaa lihaksiston yleistä harjoituskestävyyttä. Lihaskestävyysharjoittelu lisää 
        lihaksiston paikallista hiussuonitusta ja lisää mitokondrioiden määrää, mikä parantaa lihaksiston 
        paikallista hapellista energianmuodostusta.</p>
    
    <p>Kestovoimaharjoittelulla parannetaan lihaksen välittömiä (hapettomia) energiantuottomekanismeja ja 
        maitohaponsietokykyä. Kestovoimaharjoittelu parantaa myös lihaksiston taloudellisuutta parantamalla solujen 
        rekrytointia (lihaksen sisäistä, solujen välistä koordinaatiota).</p>
    
    <h4>Kestovoimaharjoittelu käytännössä</h4>
    
    <table>
        <thead>
            <tr>
                <th>Voiman laji</th>
                <th>Toistot ja kuorma</th>
                <th>Sarjapalautus</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Lihaskestävyys</td>
                <td>15+ (0-40 %)</td>
                <td>0-30 sek</td>
            </tr>
            <tr>
                <td>Voimakestävyys</td>
                <td>12-15 (40-60 %)</td>
                <td>30-60 sek</td>
            </tr>
        </tbody>
    </table>
    
    <h4>Kestovoimaharjoittelun hyödyt</h4>
    
    <ul>
        <li>yleisen lihaskunnon parantaminen</li>
        <li>kiinteytyminen, painonhallinta</li>
        <li>ryhti ja lihastasapaino</li>
        <li>painonhallinta</li>
        <li>urheilulajia tukeva voimaharjoittelu</li>
        <li>sopii aloittelijalle</li>
    </ul>
    
    <h3>Perus- ja maksimivoima</h3>
    
    <p>Perusvoimaharjoittelu kehittää voimaa lihasmassan kasvun (hypertrofia) kautta ja maksimivoimaharjoittelu 
        hermotuksen paranemisen kautta. Useimmiten perus- ja maksimivoimaharjoittelualueella harjoittelu kuitenkin 
        kehittää voimaa samanaikaisesti molempien ominaisuuksien kautta.</p>
        
    <p>Hermostollisesta harjoittelusta johtuen varsin pienikokoinenkin urheilija voi olla suhteellisesti verrattain 
        vahva verrattuna huomattavasti isokokoisempaan kehonrakentajaan. Erityisesti painoluokkaurheilussa tällä 
        on merkitys - lihasmassan kautta hankittu lihasvoima ei välttämättä auta lajinomaisessa voimantuotossa niin 
        paljoa kuin seuraavat voiman portaat maksimivoimasta alkaen.</p>


    <h4>Perusvoimaharjoittelu käytännössä</h4>
    
    <table>
        <thead>
            <tr>
                <th>Voiman laji</th>
                <th>Toistot ja kuorma</th>
                <th>Sarjapalautus</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Perusvoima</td>
                <td>6-12 (60-80 %)</td>
                <td>1-4 min</td>
            </tr>
            <tr>
                <td>Maksimivoima</td>
                <td>1-5 (80-100+ %)</td>
                <td>3-5 min</td>
            </tr>
        </tbody>
    </table>

    
    <h4>Perus- ja maksimivoimaharjoittelun hyödyt</h4>
    
    <ul>
        <li>kiinteytyminen, lihasmassan hankinta ja kehonmuokkaus</li>
        <li>voiman hankinta</li>
        <li>urheilulajia tukeva voimaharjoittelu</li>
    </ul>
    
    <h3>Nopeusvoima</h3>
    
    <p>Nopeus on taidon, koordinaation ja lihasvoiman summa, joten nopeusvoimaharjoittelussa on tärkeässä osassa pitkäjänteinen lajinomainen taitoharjoittelu. Esimerkiksi pikajuoksussa yksittäinen ponnistus ei vaadi maksimaalista voimantuottoa, mutta sitäkin nopeampaa vaihtelua lihaksen jännittyessä ja rentoutuessa. Nopeusvoimassa on siis kyse mahdollisimman suuresta submaksimaalisesta voimantuotosta mahdollisimman lyhyessä ajassa.</p>
    
    <p>Pikavoima eroaa räjähtävästä voimasta siten, että pikavoimassa pyritään tekemään syklisesti useita toistoja mahdollisimman lyhyessä ajassa; räjähtävää voimaa harjoiteltaessa tavoite on yksittäisen toiston mahdollisimman nopea ja tehokas suoritus.</p>
    
    <h4>Nopeusvoimaharjoittelu käytännössä</h4>
    
    <table>
        <thead>
            <tr>
                <th>Voiman laji</th>
                <th>Toistot ja kuorma</th>
                <th>Sarjapalautus</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Pikavoima</td>
                <td>3-8 (0-50 %)</td>
                <td>2-5 min</td>
            </tr>
            <tr>
                <td>Räjähtävä voima</td>
                <td>1-6 (40-70 %)</td>
                <td>2-5 min</td>
            </tr>
        </tbody>
    </table>
    
    <h4>Nopeusvoimaharjoittelun hyödyt</h4>
    
    <ul>
        <li>hermostollinen lihaskoordinaation kehittyminen</li>
        <li>urheilulajille ominainen voimantuotto, lajinomainen nopeuden kehittyminen</li>
    </ul>

    <h4>Yhteenveto</h4>
    <p>Monipuolinen harjoittelu siis huomioi eri voiman osa-alueet. Olipa tavoitteena kehonmuokkaus, nopeuden kehittäminen tai maksimaalinen voimantuotto, rakenna siis kivijalka kuntoon ja kehitä sen päälle eri osa-alueita kohti omaa tavoitettasi.</p>



</article>




<section class="container">
    <h2>Lue seuraavaksi</h2>
    <div class="row">
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='voimaa_pakaratreenilla_osa_1' title='Osaatko aktivoida pakaralihaksesi?' titlePic='2023/pihasavotta.jpg' blogDate='' firstPara='Pakaralihakset ovat ihmisen voimakkain lihasryhmä. Artikkelisarjan ensimmäisessä osassa käymme läpi pakaralihasten tehtävät sekä pari testiä, joilla voit kokeilla osaatko aktivoida pakarasi.'></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='vinkit_kestavaan_muutokseen' title='12 vinkkiä pysyvään muutokseen' titlePic='2023/healthy.jpg' firstPara='Haikailetko viimeistään kevätlumien sulaessa kadonnutta alkuvuoden intoa ja treenimotivaatiota? Lue tästä Dynamosalin vinkit kestävään muutokseen.' blogDate=''></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa' title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate='' firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
        </article>
    </div>
</section>



</div>
{/if}

<style>


</style>